import React from 'react';

// Each feature gets a clean line icon. Paths are Heroicons-style (24x24).
const Icon = ({ d }) => (
  <svg fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.7} aria-hidden>
    {Array.isArray(d)
      ? d.map((p, i) => <path key={i} strokeLinecap="round" strokeLinejoin="round" d={p} />)
      : <path strokeLinecap="round" strokeLinejoin="round" d={d} />}
  </svg>
);

const features = [
  { title: 'Match Scoring', icon: 'M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01' },
  { title: 'Challenge Rivals', icon: 'M13 10V3L4 14h7v7l9-11h-7z' },
  { title: 'Pro Scorecards', icon: 'M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z' },
  { title: 'Free Tournaments', icon: ['M16 7a4 4 0 11-8 0 4 4 0 018 0z', 'M12 14v3m-4 4h8a1 1 0 001-1 5 5 0 00-10 0 1 1 0 001 1z', 'M5 8H4m16 0h-1'] },
  { title: 'Player Profiles', icon: 'M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z' },
  { title: 'Player Stats', icon: 'M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z' },
  { title: 'XP & Leaderboards', icon: 'M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z' },
  { title: 'Team Chat', icon: 'M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.86 9.86 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z' },
  { title: 'Live Matches', icon: 'M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z' },
  { title: 'Match Highlights', icon: 'M7 4v16M17 4v16M3 8h4m10 0h4M3 12h18M3 16h4m10 0h4M4 20h16a1 1 0 001-1V5a1 1 0 00-1-1H4a1 1 0 00-1 1v14a1 1 0 001 1z' },
];

const Features = () => {
  return (
    <section id="features" className="cf-section cf-section--alt">
      <div className="cf-container cf-rel-z">
        <div className="cf-section-head cf-reveal">
          <span className="cf-eyebrow">Features</span>
          <h2 className="cf-h2">
            Everything you need,
            <br />
            <span className="cf-text-gradient">all in one app</span>
          </h2>
          <span className="cf-sub">From scoring your game to sharing it live — every feature is 100% free.</span>
        </div>

        <div className="cf-fgrid">
          {features.map((feature, i) => (
            <div
              key={feature.title}
              className="cf-ftile cf-reveal"
              style={{ '--cf-d': `${Math.min(i, 5) * 0.04}s` }}
            >
              <div className="cf-ftile__ic"><Icon d={feature.icon} /></div>
              <h3 className="cf-ftile__title">{feature.title}</h3>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;
